import {request} from '@/helpers/apiClient'
import {PRODUCTS_CONFIG} from '@/utils/constants/apiConfig/productsConfig'
import {HTTP_METHODS} from '@/utils/constants/httpMethods'

export const getProductList = (body, queryParams) => request(PRODUCTS_CONFIG.PRODUCT_LIST(queryParams), {data: body})
export const getProductCsvFile = (body, queryParams) =>
  request(PRODUCTS_CONFIG.PRODUCT_CSV_DOWNLOAD(queryParams), {data: body})
export const updateProduct = productData => request(PRODUCTS_CONFIG.UPDATE_PRODUCT, {data: productData})
export const uploadProductMedia = (productId, mediaData) =>
  request(PRODUCTS_CONFIG.UPLOAD_PRODUCT_MEDIA(productId), {formData: mediaData})

/**
 * POST /v1/api/product/validate - checks which of the given product IDs exist.
 * @param {string[]} productIds
 * @returns {Promise<Record<string, boolean>>} map of productId -> whether it's valid
 */
export const validateProductIds = (productIds = []) =>
  request(
    {
      endPoint: 'product/validate',
      method: HTTP_METHODS.POST,
      baseUrlKey: 'inventoryApiUrl',
      queryParams: {scope: 'pepsi'},
    },
    {data: productIds}
  )

/**
 * PATCH /v1/api/product/bulk - bulk edit PO-approved P&P editable product fields.
 * @param {{ mode: 'UNIFORM' | 'PER_PRODUCT', productIds?: string[], fieldValues?: object, edits?: {productId: string, fieldValues: object}[] }} body
 * @param {{ countryCode?: string, salesOrg?: string }} [context]
 */
export const bulkEditProducts = (body, {countryCode, salesOrg} = {}) =>
  request(
    PRODUCTS_CONFIG.BULK_EDIT_PRODUCTS({
      ...(countryCode ? {countryCode} : {}),
      ...(salesOrg ? {salesOrg} : {}),
    }),
    {data: body}
  )
